import { render, staticRenderFns } from "./SearchLayout.vue?vue&type=template&id=0c433e4d&scoped=true&"
import script from "./SearchLayout.vue?vue&type=script&lang=js&"
export * from "./SearchLayout.vue?vue&type=script&lang=js&"
import style0 from "./SearchLayout.vue?vue&type=style&index=0&id=0c433e4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c433e4d",
  null
  
)

export default component.exports